import React from "react";
import "./OurTeam.css";

// Import team member images (you'll need to add these)
import CEOPhoto from "../assets/images/ceo-photo.jpg";
import TeamMember1 from "../assets/images/team-member-1.jpg";
import TeamMember2 from "../assets/images/team-member-2.JPG";

const OurTeam = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Raja Hamza",
      position: "Creative Director",
      image: TeamMember1,
      description:
        "Overseeing all design and creative aspects of our projects.",
    },
    {
      id: 2,
      name: "Muhammad Sheraz",
      position: "Senior Web App Developer ",
      image: TeamMember2,
      description: "Developing high end Web app Products.",
    },
  ];

  return (
    <section id="our-team" className="our-team-section">
      <div className="container">
        {/* CEO Section */}
        <div className="ceo-section mb-5">
          <div className="row align-items-center">
            <div className="col-lg-4 mb-4 mb-lg-0">
              <div className="ceo-image-container">
                <img
                  src={CEOPhoto}
                  alt="Muhammad Talha Javed - CEO & Founder"
                  className="ceo-image"
                />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="ceo-content">
                <h3 className="ceo-name fw-bold">Muhammad Talha Javed</h3>
                <p className="ceo-position fw-semibold">CEO & Founder</p>

                {/* CEO Message */}
                <div className="ceo-message mt-4">
                  <h4 className="message-title fw-bold mb-3">
                    Message from Our CEO
                  </h4>
                  <div className="message-content">
                    <p className="message-text">
                      "Welcome to Teckpik! Our journey began with a simple
                      vision: to create digital experiences that not only meet
                      but exceed our clients' expectations. We believe in the
                      power of technology to transform businesses and create
                      meaningful connections.
                    </p>
                    <p className="message-text">
                      At Teckpik, we're more than just a service provider -
                      we're your partners in growth. Our team of dedicated
                      professionals works tirelessly to ensure that every
                      project we undertake becomes a success story. We combine
                      innovation, expertise, and passion to deliver solutions
                      that drive real results.
                    </p>
                    <p className="message-text">
                      Thank you for considering Teckpik. We look forward to
                      helping you achieve your digital goals and building a
                      lasting relationship based on trust, quality, and mutual
                      success."
                    </p>
                  </div>
                  <div className="ceo-signature mt-4">
                    <p className="signature-name fw-bold mb-1">
                      Muhammad Talha Javed
                    </p>
                    <p className="signature-position small">
                      CEO & Founder, Teckpik <br /> muhammadtalhajavid@gmail.com
                    </p>
                    <p className="signature-position small"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Team Members Grid */}
        <div className="team-members-section">
          <h3 className="section-subtitle text-center mb-4 fw-bold">
            Our Expert Team
          </h3>
          <div className="row g-4">
            {teamMembers.map((member) => (
              <div key={member.id} className="col-lg-3 col-md-6">
                <div className="team-member-card">
                  <div className="member-image-container">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="member-image"
                    />
                    <div className="member-overlay">
                      <div className="overlay-content">
                        <p className="overlay-text">{member.description}</p>
                      </div>
                    </div>
                  </div>
                  <div className="member-info text-center">
                    <h4 className="member-name fw-bold">{member.name}</h4>
                    <p className="member-position">{member.position}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
